export function helpTargetSelector(helpTarget: string) {
  return `[data-help-target="${helpTarget}"]`;
}

export function queryHelpTarget(helpTarget: string) {
  return document.querySelector<HTMLElement>(helpTargetSelector(helpTarget));
}
